import * as React from 'react';
import './emptyManagerView.scss';

export default class EmptyManagerView extends React.Component {

    render(): React.ReactNode {
        return (
            <div className="nomst-empty-manager-view">
                <img
                    alt=""
                    src={require('contents/icon-team_review.svg')}
                    className="nomst-empty-manager-view__pending-cycle-icon"
                />
                <div className="nomst-empty-manager-view__body">
                    <h2 className="nomst-empty-manager-view__header">
                        It&apos;s almost time to make pay decisions
                    </h2>
                    <div className="nomst-empty-manager-view__sub-header">
                        Your HR team is busy setting up the next cycle. You will be notified by
                        email when your team is ready.
                    </div>
                </div>
            </div>
        );
    }
}